import axiosPublicClient from "../../../../axiosPublicClient"
import axiosClient from "../../../../axiosClient"

const service = async ({
    backgroundRequestId,
    key,
    file,
    fileName,
    fileExtension,
    formType,
}) => {

    let candidateMediaUrlResponse

    if (backgroundRequestId) {
        if (formType === "client_form") {
            candidateMediaUrlResponse = await axiosClient.post(`/candidate-client-media-url`, {
                backgroundRequestId,
                fileName,
                fileExtension,
            })
        }
        else {
            candidateMediaUrlResponse = await axiosClient.post(`/candidate-cra-media-url`, {
                backgroundRequestId,
                fileName,
                fileExtension,
            })
        }
    }
    else {
        candidateMediaUrlResponse = await axiosPublicClient.post(`/candidate-media-url`, {
            key,
            fileName,
            fileExtension,
        })
    }

    if (!candidateMediaUrlResponse?.data?.url || !candidateMediaUrlResponse?.data?.key) {
        throw new Error("Upload URL or key missing from response")
    }

    const { url, key: assetKey, } = candidateMediaUrlResponse.data

    // Step 2: Upload the file to the S3 pre-signed URL
    await axiosPublicClient.put(url, file, {
        headers: {
            "Content-Type": file.type,
        },
    })

    return {
        key: assetKey,
    }
}

export default service
